// import FormCoordendas from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/form_coordendas";
import { gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg6, ROUTER_PATHS } from "@/shared";
import { useFetchCategoryProduct } from "@/shared/actions/erp";
import { usePostServicioDigital, usePutServicioDigital } from "@/shared/actions/erp/servicio_digital.actions";
import { CustomAutocomplete, CustomTextArea, CustomTextField, CustomTextFieldNumberComponente, SingleFormBoxScene } from "@/shared/components/ui";

import { IServicioDigital } from "@/shared/interfaces";
import { CATEGORYPRODUCT } from "@/shared/interfaces/erp/inventario";
import { Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
type SaveServiciosDigitalesProps = {
  title: string;
  dataServicioDigital?: Partial<IServicioDigital>;
}
type SaveFormData = Partial<IServicioDigital> & {
  precio1?: number | string;
  precio2?: number | string;
  precio3?: number | string;
}

export default function SaveServiciosDigitales({ title, dataServicioDigital }: SaveServiciosDigitalesProps) {

  const navigate = useNavigate()
  const isEditPage = !!dataServicioDigital

  
  ///* global state -----------------

  //*
  const form = useForm<SaveFormData>({})

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = form


  const { data: categoriaProductos, isLoading: isLoadingCategoriaProducto } = useFetchCategoryProduct({
    page_size: 600,
    estado: true,
  });
  const {mutateAsync:postServicioDigital}=usePostServicioDigital({
    navigate,
    enableSuccessAlert:true,
    returnUrl:ROUTER_PATHS.solucionesDigitales.servicios_nav
  })
  const {mutateAsync:putServicioDigital}=usePutServicioDigital({
    navigate,
    enableSuccessAlert:true,
    returnUrl:ROUTER_PATHS.solucionesDigitales.servicios_nav
  })


  const onSubmit = () => {
    const formatData = {
      ...form.getValues(),
      precios: [
        {
          nombre: "Precio 1",
          estado:true,
          precio: form.getValues().precio1
        },
        {
          nombre: "Precio 2",
          estado:true,
          precio: form.getValues().precio2
        },
        {
          nombre: "Precio 3",
          estado:true,
          precio: form.getValues().precio3
        }
      ]
    }
    if(!!dataServicioDigital){
      putServicioDigital({
        id:dataServicioDigital.id_servicio_digital!,
        data:{
          ...formatData,
          precios: formatData.precios ? formatData.precios?.map((item)=>{
            return{
              ...item,
              precio:item.precio?.toString()!
            }
          }) : undefined
        }
      })
    }else{
      postServicioDigital(formatData as IServicioDigital)
    }
    return
  }

  useEffect(()=>{
    if(!!dataServicioDigital){
      reset({
        ...dataServicioDigital,
        precio1:dataServicioDigital.precios?.[0].precio,
        precio2:dataServicioDigital.precios?.[1].precio,
        precio3:dataServicioDigital.precios?.[2].precio,
      })
    }
  },[dataServicioDigital])

  ///const{control}= form;

  return (
    <>
      <SingleFormBoxScene      
        titlePage={title}
        onCancel={() => {
          navigate(ROUTER_PATHS.solucionesDigitales.servicios_nav);
        }}
        onSave={handleSubmit(onSubmit)}
      >
        <Grid container spacing={3} marginY={5}>
          {
            isEditPage && (
              <>
                <CustomTextField
                  label={"CÓDIGO *"}
                  error={errors.codigo}
                  helperText={errors.codigo?.message}
                  control={control}
                  name="codigo"
                  defaultValue={form.getValues().codigo || ""}
                  disabled={isEditPage}
                  size={gridSizeMdLg6}
                  
                />
                {/* Número de Referencia (required) */}
                <CustomTextField
                  label={"NÚMERO DE REFERENCIA *"}
                  error={errors.numero_referencia}
                  helperText={errors.numero_referencia?.message}
                  control={control}
                  name="numero_referencia"
                  defaultValue={form.getValues().numero_referencia || ""}
                  disabled={isEditPage}
                  size={gridSizeMdLg6}
                />
              </>
            )
          }



          {/* Nombre */}
          
            <CustomTextField
              label={"NOMBRE"}
              error={errors.nombre}
              helperText={errors.nombre?.message}
              control={control}
              name="nombre"
              defaultValue={form.getValues().nombre || ""}
              size={gridSizeMdLg6}
            />
          

          {/* Categoría de Producto */}
          
            {/* <CustomTextField
              label={"CATEGORÍA DE PRODUCTO"}
              error={errors.categoria_producto}
              helperText={errors.categoria_producto?.message}
              control={control}
              name="categoria_producto"
              defaultValue={form.getValues().categoria_producto || ""}
            /> */}
            <CustomAutocomplete<CATEGORYPRODUCT>
              label={"CATEGORÍA DE PRODUCTO"}
              name="categoria_producto"
              actualValueKey="codigo"
              options={categoriaProductos?.data?.data || []}
              valueKey="nombre"
              defaultValue={form.getValues().categoria_producto || ''}
              isLoadingData={isLoadingCategoriaProducto}
              control={control}
              error={errors.categoria_producto}
              helperText={errors.categoria_producto?.message}
              onChangeValue={(e) => {
                reset({ ...form.getValues(), categoria_producto: e });

              }}
              size={gridSizeMdLg6}
            />
          

          {/* Descripción */}
          
            <CustomTextArea
              label={"DESCRIPCIÓN"}
              error={errors.descripcion}
              helperText={errors.descripcion?.message}
              control={control}
              name="descripcion"
              defaultValue={form.getValues().descripcion || ""}
              rows={3}
            />
          

          {/* Precios Section */}
          
          <Grid item {...gridSizeMdLg12}>
            <Typography variant="subtitle1" fontWeight="bold" mb={2}>
              Precios
            </Typography>
          </Grid>
          
          <CustomTextFieldNumberComponente
            label={"PRECIO 1"}
            error={errors.precio1}
            helperText={errors.precio1?.message}
            control={control}
            name="precio1"
            defaultValue={form.getValues().precio1 || ""}
            size={gridSizeMdLg4}
          />
          

          
          <CustomTextFieldNumberComponente
            label={"PRECIO 2"}
            error={errors.precio2}
            helperText={errors.precio2?.message}
            control={control}
            name="precio2"
            defaultValue={form.getValues().precio2 || ""}
            size={gridSizeMdLg4}
          />
          

          <CustomTextFieldNumberComponente
            label={"PRECIO 3"}
            error={errors.precio3}
            helperText={errors.precio3?.message}
            control={control}
            name="precio3"
            defaultValue={form.getValues().precio3 || ""}
            size={gridSizeMdLg4}
          />
          
        </Grid>
      </SingleFormBoxScene>
    </>
  )
}